import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gypsum-rock-page',
  templateUrl: './gypsum-rock-page.component.html',
  styleUrls: ['./gypsum-rock-page.component.scss']
})
export class GypsumRockPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
